import { Skeleton } from "@mui/material";

type Props = {};

const FilterFieldLoading = (props: Props) => {
  return <Skeleton width={200} height={80}></Skeleton>;
};

export default FilterFieldLoading;
